<template>
  <div class="wrapper">
    <!-- Награда за микро-шаг обучения (ролл рулетки). На игровом экране своё такое же окно ВНУТРИ
         сцены (иначе не видно в фуллскрине), поэтому здесь его не дублируем. -->
    <TutorialRoll v-if="$route.path !== '/play-web'" />
    <!-- Анти-фрод: плашка серого/чёрного списка в левом верхнем углу лобби. СЕРУЮ можно закрыть
         крестиком (это предупреждение, награды идут как обычно), ЧЁРНУЮ — НЕЛЬЗЯ (решение оунера
         2026-08-13): в чёрном списке награды не начисляются, и игрок обязан видеть причину постоянно,
         а не «промигать» её случайным кликом. -->
    <div v-if="fraudNotice" class="fraud-banner" :class="fraudNotice.cls">
      <button
          v-if="fraudNotice.level !== 'black'"
          class="fraud-banner__close"
          :title="$t('common.close')"
          @click="dismissFraud"
      >×</button>
      {{ fraudNotice.text }}
    </div>
    <!-- Итог привязки Telegram по одноразовому коду (мини-апп открыт ссылкой `?startapp=link_...`).
         Без плашки игрок не понял бы, сработала ли привязка: экран просто перезагружается в лобби. -->
    <div v-if="tgLinkNotice" class="tg-link-notice" @click="dismissTgLinkNotice">
      <span>{{ tgLinkNotice }}</span>
      <button class="tg-link-notice__close" :aria-label="$t('common.close')">×</button>
    </div>
    <!-- Сезон (Турнир): видно на ВСЕХ переиспользуемых экранах (Pack/PVP/Колесо/Рынок), пока активна
         сезонная сессия (свой JWT суб-аккаунта, изолированный от основного). -->
    <div
        v-if="this.authorized && this.$store.state.season.active && !['/tournament', '/tournaments'].includes(this.$route.path)"
        class="season-banner"
    >
      <span class="season-banner__label">{{ $t('app.seasonBanner', { title: this.$store.state.season.seasonTitle || '—' }) }}</span>
      <span v-if="seasonCountdown" class="season-banner__count">{{ seasonCountdown.label }}: {{ seasonCountdown.text }}</span>
      <button class="season-banner__exit" @click="exitSeason">{{ $t('app.seasonExit') }}</button>
    </div>
    <button
        v-if="this.authorized && this.$route.path != '/' && !status"
        class="back"
        @click="goBack"
    >
      {{ $t('common.back') }}
    </button>
    <router-view v-if="this.authorized && !status"></router-view>
    <div class="chess__blocker" v-if="status === 'play'">
      {{ $t('app.rotatePhone') }}
    </div>
    <div v-if="!this.authorized" class="card">
      <!-- Первый запуск мини-аппа: сперва спрашиваем, новичок или уже есть аккаунт (иначе молчаливая
           регистрация плодила дубли у игроков со старым аккаунтом). -->
      <TelegramWelcome v-if="tgWelcome" @created="onTgCreated" @login="tgWelcome = false" />
      <LoginForm v-else/>
    </div>
    <div
        v-else
        v-show="status === 'play'"
        class="chess"
    >
      <VueUnity
          v-if="!webClientEnabled"
          :unity="unity"
          :width="unityWidth"
          :height="unityHeight"
      />
    </div>

    <!-- Уведомление о новой версии ВО ВРЕМЯ партии: тихо перезагружать нельзя (прервётся игра),
         поэтому показываем плашку с таймаутом исчезновения и крестиком. Обновление применится
         автоматически при возврате в лобби (updatePending). В лобби обновление идёт молча (reload).
         Teleport в активный fullscreen-элемент: в полноэкранной партии браузер рендерит только его
         поддерево → без переноса плашка не видна (та же причина, что у окна итогов/превращения). -->
    <Teleport :to="toastTarget">
      <div v-if="updateToast" class="update-toast">
        <span class="update-toast__text">{{ $t('app.updateAvailable') }}</span>
        <button class="update-toast__close" @click="dismissUpdateToast" :aria-label="$t('common.close')">×</button>
      </div>
    </Teleport>

    <!-- Плановое обслуживание: обратный отсчёт до работ (не блокирует, просит завершить партии). -->
    <Teleport :to="toastTarget">
      <div v-if="!maintenanceActive && maintenanceCountdown" class="maint-banner">
        {{ $t('app.maintenanceBanner', { when: maintenanceCountdown }) }}
      </div>
    </Teleport>

    <!-- Идут технические работы: блокирующий затемнённый экран поверх всего. -->
    <Teleport :to="toastTarget">
      <div v-if="maintenanceActive" class="maint-overlay">
        <div class="maint-overlay__box">{{ $t('app.maintenance') }}<br>{{ $t('app.maintenanceSorry') }}</div>
      </div>
    </Teleport>

    <!-- НОМЕР СБОРКИ (просьба оунера 2026-08-14): по нему видно, что именно сейчас открыто у игрока —
         дата сборки и хеш коммита. Только в лобби: игровой экран занимает всё окно, и подпись там
         лезла бы в интерфейс партии. -->
    <div v-if="buildLabel && showBuild" class="build-label">{{ buildLabel }}</div>

    <!-- Полоса загрузки контента игры (после свежего логина): прогрев кэша ассетов. Уже-залогиненному
         игроку прогрев идёт тихо в фоне. 🔴 Полоса НЕ перекрывает экран (2026-08-25): играть можно
         сразу, кнопка лишь убирает её с глаз — сама загрузка продолжается в фоне. -->
    <div v-if="preloadProgress !== null" class="preloader">
      <div class="preloader__box">
        <div class="preloader__title">{{ $t('app.preloading') }}</div>
        <div class="preloader__bar"><div class="preloader__fill" :style="{ width: Math.round(preloadProgress * 100) + '%' }"></div></div>
        <div class="preloader__pct">{{ Math.round(preloadProgress * 100) }}%</div>
        <button class="preloader__skip" @click="skipPreload">{{ $t('common.close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import TutorialRoll from '@/components/tutorial/TutorialRoll.vue';
import { t } from '@/i18n';
import { fmtRemaining } from '@/i18n/format';
import VueUnity from 'unity-webgl/vue';
import LoginForm from "@/components/LoginForm";
import TelegramWelcome from "@/components/TelegramWelcome";
import Unity from "@/./unity.js"
import { preloadAssets } from "@/preloadAssets";
import { applyAuthHeader, getJwt, getLegacyToken } from '@/session';
import {
  applyTheme,
  clearJwtIfForeignTelegram,
  isTelegram,
  rememberTelegramOwner,
  telegramUserId,
  prepareViewport,
  setupBackButton,
  telegramLocale,
  telegramLink,
  telegramLinkByCode,
  telegramLogin,
  linkCodeFromStart,
  watchSafeArea,
} from '@/telegram';

// очень медленный / data-saver канал → не греем ассеты в фоне (чтобы не отнимать канал у игрового
// WebSocket); ассеты теперь лёгкие (WebP) и догрузятся по месту. Net Info API есть не везде → нет = не slow.
function isSlowConnection() {
  const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!c) return false;
  return !!c.saveData || ['slow-2g', '2g'].includes(c.effectiveType);
}

export default {
  name: 'App',
  components: { TutorialRoll,
    VueUnity,
    LoginForm,
    TelegramWelcome
  },
  async mounted() {
    // TELEGRAM MINI APP: развернуть окно и запретить свайп-сворачивание (свайп рвёт сокет, а сервер
    // завершает партию по неактивности). Вне Telegram — no-op.
    prepareViewport();
    // Безопасные зоны (вырез устройства + шапка Telegram) в CSS-переменные `--tg-safe-*`, кнопка
    // «Назад» самого Telegram вместо нашей и тёмная шапка под палитру игры. Вне Telegram — no-op.
    watchSafeArea();
    setupBackButton(this.$router, () => this.goBack());
    applyTheme();
    // Реф-код из ссылки chesszombies.fun/?ref=CODE — ловим ОДИН раз при загрузке и держим в
    // localStorage до регистрации (переживает переход на форму «Регистрация»). Использует CREATE_ACCOUNT.
    const refCode = new URLSearchParams(window.location.search).get('ref');
    if (refCode) localStorage.setItem('cz_ref_code', refCode);
    // Язык из Telegram точнее языка WebView; ставим только при ПЕРВОМ запуске (иначе перебивали бы
    // выбор игрока на экране «Options»).
    if (!localStorage.getItem('cz_lang')) {
      const lang = telegramLocale();
      if (lang) localStorage.setItem('cz_lang', lang === 'ru' ? 'ru' : 'en');
    }
    // Сезон (Турнир): Vuex сбрасывается перезагрузкой страницы, но cookie 'jwt' уже держит сезонный токен
    // (TRY_AUTH ниже подхватит его сам) — тут только поднимаем баннер/бэкап основного токена из localStorage.
    this.$store.dispatch('RESTORE_SEASON');
    this.$store.dispatch('FETCH_MESSAGES', this); // каталог редактируемых текстов игры (бой и др.)
    // const bgSound = document.createElement('audio');
    // bgSound.loop = true;
    // bgSound.src = '/sounds/bg.mp3'
    // const app = document.getElementById('app')
    // app.addEventListener("click", () => bgSound.play())
    // 🔗 ПРИВЯЗКА TELEGRAM ПО ОДНОРАЗОВОМУ КОДУ (2026-08-18, запасной путь к виджету). Игрок взял код
    // на сайте и открыл ссылку `t.me/<бот>/<апп>?startapp=link_<код>`. Личность подтверждает `initData`,
    // аккаунт задаёт КОД, поэтому своего JWT здесь может не быть вовсе — привязываем ДО любого входа,
    // а дальше обычный телеграм-вход уже приведёт игрока в его собственный аккаунт.
    const linkCode = linkCodeFromStart();
    if (linkCode) await this.linkByStartCode(linkCode);

    if (!this.authorized || !this.$store.state.auth.jwt) {
      // 🔴 СОХРАНЁННАЯ СЕССИЯ ПРИНАДЛЕЖИТ ДРУГОМУ ТЕЛЕГРАМ-АККАУНТУ? (баг оунера 2026-08-15: на одном
      // телефоне переключил телеграм-аккаунт, открыл мини-апп — вошёл под ПЕРВЫМ игроком). Токен в
      // хранилище имел приоритет над `initData`, поэтому чужая сессия просто переживала смену
      // аккаунта. Чистим её ДО проверки токена — дальше сработает обычный телеграм-вход.
      clearJwtIfForeignTelegram();
      const savedJwt = getJwt();
      if (savedJwt) {
        this.resuming = true; // была сессия → восстановление (прогрев ассетов в фоне, без полосы)
        applyAuthHeader(this.axios, savedJwt);
        // 🔴 МЁРТВАЯ СЕССИЯ НЕ ДОЛЖНА РОНЯТЬ ЗАПУСК (баг оунера 2026-08-16: удалил аккаунт, вход в
        // мини-апп упирался в форму логина). `TRY_AUTH` не ловит свои ошибки, и 401 по протухшему/
        // удалённому аккаунту выбрасывал исключение прямо из `mounted` — не выполнялись ни
        // телеграм-вход, ни `setupTokenRefresh`/`setupVersionCheck`/`setupMaintenance`.
        let authFailed = null;
        try {
          await this.$store.dispatch('TRY_AUTH', this);
        } catch (e) { authFailed = ((e || {}).response || {}).status || 0; }
        if (this.authorized) {
          await this.checkTelegramOwner(); // сессия чужого телеграма → перевойти по initData
        } else {
          // 🔴 ТОКЕН ВЫБРАСЫВАЕМ ТОЛЬКО ПО ОТКАЗУ СЕРВЕРА (401/403). Сетевой сбой или 5xx — временные:
          // разлогинить по ним значит выкинуть живого игрока из-за пропавшего на секунду интернета.
          const dead = authFailed === 401 || authFailed === 403;
          if (dead) this.$store.dispatch('LOGOUT', this); // мёртвый токен — из обоих хранилищ
          if (dead && isTelegram()) await this.telegramStart();
          else this.resuming = false;
        }
      } else if (isTelegram()) {
        await this.telegramStart();
      } else if (getLegacyToken()) {
        this.resuming = true;
        this.$store.dispatch('SET_TOKEN', getLegacyToken())
        this.$store.dispatch('TRY_AUTH', this).catch(() => { this.resuming = false; });
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token')
        if (token) this.resuming = true; // вход по токену из URL — тоже восстановление
        this.$store.dispatch('SET_TOKEN', token)
        this.$store.dispatch('TRY_AUTH', this).catch(() => { this.resuming = false; });
      }
    }

    // const unity_version = process.env.VUE_APP_UNITY_VERSION;
    // fetch(`/unity_client/Build/${unity_version}.data`, {credentials: "same-origin", cache: "force-cache"});
    // fetch(`/unity_client/Build/${unity_version}.wasm`, {credentials: "same-origin", cache: "force-cache"});

    this.setupTokenRefresh();
    this.setupVersionCheck();
    this.setupMaintenance();
    // Турнир: 1с-тик обратного отсчёта этапа + периодический опрос статуса/дат (бэк сам двигает этапы).
    this.seasonTick = setInterval(() => { this.seasonNow = Date.now(); }, 1000);
    this.seasonPoll = setInterval(() => {
      if (this.$store.state.season.active) this.$store.dispatch('REFRESH_SEASON_STATE', this);
    }, 30000);
    // отслеживаем активный fullscreen-элемент → Teleport плашки обновления внутрь него
    document.addEventListener('fullscreenchange', this.onFsElementChange);
    document.addEventListener('webkitfullscreenchange', this.onFsElementChange);

    Unity.on('screenExpand', this.expandScreen);
    Unity.on('backToPVP', this.backToPVP)
  },
  beforeUnmount() {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
    if (this.versionTimer) clearInterval(this.versionTimer);
    if (this.updateToastTimer) clearTimeout(this.updateToastTimer);
    if (this.maintPollTimer) clearInterval(this.maintPollTimer);
    if (this.maintTickTimer) clearInterval(this.maintTickTimer);
    if (this.tgLinkTimer) clearTimeout(this.tgLinkTimer);
    if (this.seasonTick) clearInterval(this.seasonTick);
    if (this.seasonPoll) clearInterval(this.seasonPoll);
    document.removeEventListener('visibilitychange', this.onVisibleCheckVersion);
    window.removeEventListener('focus', this.onVisibleCheckVersion);
    document.removeEventListener('fullscreenchange', this.onFsElementChange);
    document.removeEventListener('webkitfullscreenchange', this.onFsElementChange);
  },
  data() {
    return {
      unityWidth: "896",
      unityHeight: "414",
      fullScreen: false,
      refreshTimer: null,
      preloadProgress: null, // null = полоса скрыта; 0..1 = прогресс прогрева ассетов после логина
      preloadStarted: false, // прогрев запущен (фон или с полосой) — не дублировать
      resuming: false,       // при старте была сессия (cookie/token) → восстановление, не свежий логин
      tgWelcome: false,      // мини-апп открыт НЕЗНАКОМЫМ телеграмом → экран «новичок / уже есть аккаунт»
      tgLinkNotice: '',      // результат привязки по одноразовому коду (плашка сверху, гаснет сама)
      tgLinkTimer: null,     // таймер скрытия этой плашки
      versionTimer: null,    // опрос version.json (авто-обновление кэша у игроков)
      updatePending: false,  // обнаружена новая версия — обновиться при возврате в лобби
      updateToast: false,    // показываем плашку «доступно обновление» (только во время партии)
      updateToastTimer: null, // авто-скрытие плашки по таймауту
      fsElement: null,       // активный fullscreen-элемент → Teleport плашки обновления туда (видна в фуллскрине)
      maintenanceActive: false, // идут технические работы → блокирующий оверлей поверх всего
      maintScheduledAt: null,   // запланированное время активации (unix-секунды сервера) или null
      maintSkew: 0,             // server_time − client_time на момент опроса (отсчёт не зависит от часов клиента)
      maintRemain: null,        // секунд до работ (для обратного отсчёта)
      maintPollTimer: null,     // опрос /maintenance
      maintTickTimer: null,     // ежесекундный пересчёт отсчёта
      fraudDismissedSeq: parseInt(localStorage.getItem('cz_fraud_dismissed_seq') || '0', 10), // закрытый номер попадания в списки
      seasonNow: Date.now(),    // тикающие «сейчас» для обратного отсчёта этапа турнира
      seasonTick: null,         // 1с-таймер пересчёта отсчёта
      seasonPoll: null          // периодический опрос статуса/дат турнира (авто-переходы этапов на бэке)
    }
  },
  watch: {
    // авторизация стала true. resuming=true (на старте была сессия) → прогрев ТИХО в фоне (уже залогинен);
    // resuming=false (вход через форму) → прогрев с ПОЛОСОЙ (свежий логин). После — флаг сбрасываем.
    authorized(now, was) {
      if (now && !was) { this.startPreload(!this.resuming); this.resuming = false; this.linkTelegramAfterLogin(); }
    },
    // вышли из партии в лобби с отложенным обновлением → применяем его молча (reload).
    inMatch(now) {
      if (!now && this.updatePending) this.reloadForUpdate();
    }
  },
  methods: {
    /**
     * СТРАХОВКА ОТ ЧУЖОЙ СЕССИИ В МИНИ-АППЕ (2026-08-15).
     *
     * Метку владельца (`cz_tg_owner`) записывают только новые входы, а у игроков, вошедших ДО этой
     * правки, её нет — тогда единственный надёжный признак даёт сервер: у аккаунта есть привязанный
     * `telegram_id`, и он обязан совпасть с тем, кто открыл мини-апп сейчас. Не совпал — это сессия
     * другого телеграм-аккаунта: выходим и входим заново по `initData`.
     * Аккаунт БЕЗ привязки не трогаем: игрок мог сознательно войти паролем, чтобы привязать его.
     */
    async checkTelegramOwner() {
      if (!isTelegram() || !this.authorized) return;
      const now = telegramUserId();
      const linked = this.$store.state.auth.telegramId;
      if (!now || !linked) return;
      if (String(linked) === String(now)) { rememberTelegramOwner(now); return; }
      this.$store.dispatch('LOGOUT', this);
      await this.telegramStart();
    },
    /**
     * ВХОД В МИНИ-АППЕ ПО `initData` — ЕДИНАЯ ТОЧКА (стартовый путь, мёртвая сессия, чужой телеграм).
     *
     * 🔴 БЕЗ ФОРМЫ, НО И БЕЗ МОЛЧАЛИВОЙ РЕГИСТРАЦИИ (решение оунера 2026-08-14): сперва спрашиваем
     * сервер «знаешь этот Telegram?» (`create: false`). Знает — входим сразу. НЕ знает — экран выбора
     * «я новичок / у меня уже есть аккаунт», иначе игрок со старым аккаунтом получал дубль, ещё
     * ничего не нажав.
     */
    async telegramStart() {
      this.resuming = true;
      const me = await telegramLogin(this.axios, { create: false });
      if (me && me.exists === false) { this.tgWelcome = true; this.resuming = false; return; }
      if (!me) { this.resuming = false; return; } // сервер не подтвердил вход → обычная форма логина
      try {
        await this.$store.dispatch('TRY_AUTH', this);
      } catch (e) { this.resuming = false; }
    },
    /**
     * ПРИВЯЗКА ПО ОДНОРАЗОВОМУ КОДУ ИЗ ССЫЛКИ ЗАПУСКА (`?startapp=link_<код>`).
     *
     * 🔴 ПОСЛЕ ПРИВЯЗКИ ВЫХОДИМ ИЗ ТЕКУЩЕЙ СЕССИИ: в мини-аппе она принадлежит авто-созданной
     * «пустышке» первого запуска, а игрок только что сказал, что его аккаунт — другой. Дальше по
     * ходу `mounted` сработает обычный вход по `initData` и приведёт уже в привязанный аккаунт.
     * Ошибка (код истёк / чужой) не должна ронять запуск — показываем плашку и идём обычным путём.
     */
    async linkByStartCode(code) {
      // 🔴 ОДИН КОД — ОДНО ПРИМЕНЕНИЕ НА УСТРОЙСТВЕ (тест оунера 2026-08-18: «привязку сделал, а
      // всплыло „ссылка истекла“»). `start_param` живёт весь запуск мини-аппа, и повторный монтаж
      // приложения (перезагрузка страницы, авто-обновление сборки, повторное открытие ссылки) слал
      // код второй раз. Сервер такой повтор теперь принимает, но лишний запрос всё равно не нужен.
      let done = '';
      try { done = window.localStorage.getItem('cz_tg_link_code') || ''; } catch (e) { /* нет хранилища */ }
      if (done === code) return;

      this.resuming = true;
      let ok = false;
      try {
        const r = await telegramLinkByCode(this.axios, code);
        ok = !!(r && r.telegram_id);
      } catch (e) { ok = false; }
      if (ok) {
        try { window.localStorage.setItem('cz_tg_link_code', code); } catch (e) { /* нет хранилища */ }
      }
      this.showTgLinkNotice(ok ? t('profile.tgLinked') : t('profile.tgCodeFailed'));
      // Сессия в мини-аппе могла принадлежать «пустышке» первого запуска — входим заново по initData
      // (ниже по `mounted`), уже как привязанный игрок.
      this.$store.dispatch('LOGOUT', this);
      this.resuming = false;
    },
    // Плашка результата привязки. Держим ДОЛГО и даём закрыть тапом: игрок в этот момент смотрит на
    // экран запуска мини-аппа, и короткое уведомление он просто не успевает прочитать.
    showTgLinkNotice(text) {
      this.tgLinkNotice = text;
      if (this.tgLinkTimer) clearTimeout(this.tgLinkTimer);
      this.tgLinkTimer = setTimeout(() => { this.tgLinkNotice = ''; }, 20000);
    },
    dismissTgLinkNotice() {
      if (this.tgLinkTimer) clearTimeout(this.tgLinkTimer);
      this.tgLinkNotice = '';
    },
    // Игрок выбрал «я новичок» — аккаунт уже создан телеграм-входом, осталось поднять его данные.
    async onTgCreated() {
      this.tgWelcome = false;
      this.resuming = false; // свежая регистрация → прогрев ассетов с полосой, как после логина
      await this.$store.dispatch('TRY_AUTH', this);
    },
    // 🔴 ПРИВЯЗКА TELEGRAM СРАЗУ ПОСЛЕ ВХОДА ПАРОЛЕМ (2026-08-14). Метку ставит кнопка «У меня уже есть
    // аккаунт» в профиле: игрок выходит из авто-созданного телеграм-аккаунта, входит своим логином —
    // и Telegram привязывается сам. Без этого ему пришлось бы после входа снова идти в профиль и искать
    // кнопку, а до тех пор каждый запуск мини-аппа возвращал бы его в чужой пустой аккаунт.
    async linkTelegramAfterLogin() {
      if (!isTelegram()) return;
      if (localStorage.getItem('cz_tg_link_after_login') !== '1') return;
      localStorage.removeItem('cz_tg_link_after_login'); // одна попытка: отказ разбирает кнопка в профиле
      try {
        // takeover: игрок сам нажал «У меня уже есть аккаунт в игре» — перевешиваем Telegram сюда
        // (сервер разрешит только с аккаунта без пароля, то есть заведённого самим мини-аппом).
        const r = await telegramLink(this.axios, { takeover: true });
        if (r && r.telegram_id) this.$store.commit('SET_TELEGRAM_ID', r.telegram_id);
      } catch (e) { /* занят другим живым аккаунтом — об этом скажет кнопка в профиле */ }
    },
    // Авто-обновление JWT: (1) перехватчик 401 — один раз пробуем продлить токен и повторить запрос,
    // иначе разлогин; (2) проактивно продлеваем раз в 6ч, пока вкладка открыта (активный игрок не истекает).
    setupTokenRefresh() {
      this.axios.interceptors.response.use(
        (response) => response,
        async (error) => {
          const original = error.config || {};
          const is401 = error.response && error.response.status === 401;
          const skip = !original.url || original.url.includes('/users/refresh') || original.url.includes('/login');
          if (is401 && !original._retried && !skip) {
            original._retried = true;
            const ok = await this.$store.dispatch('REFRESH_TOKEN', this);
            if (ok) {
              original.headers = original.headers || {};
              original.headers.Authorization = `bearer ${this.$store.state.auth.jwt}`;
              return this.axios(original);
            }
            // Сезонный саб мог быть удалён (архив/чистка) → сезонный токен больше не валиден. Не выкидываем
            // игрока на логин — возвращаем на ОСНОВНОЙ аккаунт (бэкап токена) и уводим в раздел «Турниры».
            if (this.$store.state.season.active) {
              this.$store.dispatch('EXIT_SEASON', this);
              this.$router.push('/tournaments').catch(() => {});
              return Promise.reject(error);
            }
            this.$store.dispatch('LOGOUT', this); // продлить не вышло → на экран входа
          }
          return Promise.reject(error);
        },
      );
      this.refreshTimer = setInterval(() => {
        if (this.$store.state.auth.authorized) this.$store.dispatch('REFRESH_TOKEN', this);
      }, 6 * 60 * 60 * 1000);
    },
    expandScreen() {
      if (!this.fullScreen) {
        this.fullScreen = true
        Unity.unityInstance.SetFullscreen(true)
      } else {
        this.fullScreen = false
        Unity.unityInstance.SetFullscreen(false)
      }
    },
    exitSeason() {
      this.$store.dispatch('EXIT_SEASON', this);
      this.$router.push('/tournaments').catch(() => {});
    },
    // Компактный формат остатка времени этапа турнира (д/ч/м/с).
    fmtRemaining(sec) {
      return fmtRemaining(sec, { full: true });
    },
    backToPVP() {
      this.$store.dispatch('SET_STATUS', undefined)
      this.$router.push({ path: '/pvp' })
      this.fullScreen = false
      Unity.unityInstance.SetFullscreen(false)
    },
    // «back» — на РОДИТЕЛЬСКУЮ страницу по дереву разделов (НЕ по истории браузера):
    // PvP→меню, Настройки фигур→профиль, профиль→меню. Неизвестный роут → в главное меню.
    goBack() {
      // В сезоне «домашний» экран — рабочий стол турнира (/tournament), из него уже — список турниров.
      // Карта родителей ДОЛЖНА покрывать ВСЕ роуты лобби (иначе фолбэк уводит в главное меню:
      // так «Назад» из заданий дня прыгал в меню вместо профиля — фидбек оунера 2026-07-29).
      const parents = this.$store.state.season.active
        ? {
          '/tournament': '/tournaments', '/pvp': '/tournament', '/pack': '/tournament',
          '/wheel': '/tournament', '/market': '/tournament', '/tournaments': '/tournament', '/daily': '/tournament',
          '/profile': '/tournament', '/play-web': '/pvp', '/options': '/tournament', '/help': '/tournament',
        }
        : {
          '/pvp': '/', '/profile': '/', '/pack': '/profile', '/wheel': '/profile', '/market': '/profile',
          '/tournaments': '/', '/tournament': '/tournaments', '/daily': '/profile',
          '/play-web': '/pvp', '/options': '/', '/help': '/', '/start': '/',
        }
      this.$router.push(parents[this.$route.path] || '/')
    },
    // Прогрев игрового контента в кэш. withBar=true (свежий логин) — показываем полосу; false
    // (уже залогинен) — тихо в фоне, низким приоритетом, чтобы не мешать лобби. Только веб-клиент.
    startPreload(withBar) {
      if (this.preloadStarted || !this.webClientEnabled) return;
      this.preloadStarted = true;
      if (withBar) {
        this.preloadProgress = 0;
        preloadAssets((f) => { this.preloadProgress = f; }, 'high')
          .finally(() => { this.preloadProgress = null; });
      } else {
        if (isSlowConnection()) return; // экономия данных / 2g — фоном не греем, грузим по месту
        preloadAssets(null, 'low');
      }
    },
    // «Пропустить» полосу: скрываем её, ассеты дозагружаются в фоне (fetch'и уже идут).
    skipPreload() {
      this.preloadProgress = null;
    },
    // АВТО-ОБНОВЛЕНИЕ КЭША У ИГРОКОВ. При сборке в бандл зашивается метка VUE_APP_BUILD_VERSION, а в
    // раздачу кладётся version.json с той же меткой (build-static.sh). Открытая вкладка периодически
    // (и при возврате фокуса) опрашивает version.json без кэша и сравнивает с зашитой меткой. Расходятся
    // → был деплой: в ЛОББИ перезагружаемся молча, в ПАРТИИ показываем плашку и обновляемся при выходе.
    setupVersionCheck() {
      if (!process.env.VUE_APP_BUILD_VERSION) return; // dev-сборка без метки — не проверяем
      this.versionTimer = setInterval(this.checkVersion, 5 * 60 * 1000); // раз в 5 мин
      document.addEventListener('visibilitychange', this.onVisibleCheckVersion);
      window.addEventListener('focus', this.onVisibleCheckVersion);
    },
    onVisibleCheckVersion() {
      if (document.visibilityState !== 'hidden') { this.checkVersion(); this.fetchMaintenance(); }
    },
    // ТЕХОБСЛУЖИВАНИЕ. Публичный /maintenance опрашивается раз в ~30с (и при фокусе): active → блокирующий
    // оверлей поверх всего; scheduled_at (в будущем) → баннер обратного отсчёта «завершите партии». Отсчёт
    // считаем от server_time (skew), чтобы кривые часы клиента его не сбивали. Работает и до логина.
    setupMaintenance() {
      this.fetchMaintenance();
      this.maintPollTimer = setInterval(this.fetchMaintenance, 30 * 1000);
      this.maintTickTimer = setInterval(this.maintTick, 1000);
    },
    async fetchMaintenance() {
      try {
        const { data } = await this.axios.get('/maintenance');
        if (!data) return;
        this.maintenanceActive = !!data.active;
        this.maintScheduledAt = data.scheduled_at || null;
        if (typeof data.server_time === 'number') this.maintSkew = data.server_time - Math.floor(Date.now() / 1000);
        this.maintTick();
      } catch (e) { /* нет сети/эндпоинта — считаем, что работ нет */ }
    },
    maintTick() {
      if (this.maintScheduledAt) {
        const remain = this.maintScheduledAt - (Math.floor(Date.now() / 1000) + this.maintSkew);
        this.maintRemain = remain;
        if (remain <= 0) this.maintenanceActive = true; // локально активируем до подтверждения опросом
      } else {
        this.maintRemain = null;
      }
    },
    async checkVersion() {
      if (this.updatePending) return; // уже знаем про обновление — не дёргаем повторно
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        if (data && data.version && String(data.version) !== String(process.env.VUE_APP_BUILD_VERSION)) {
          this.onNewVersion();
        }
      } catch (e) { /* сеть моргнула — попробуем в следующий раз */ }
    },
    onNewVersion() {
      this.updatePending = true;
      if (this.inMatch) {
        // в партии перезагружать нельзя (прервётся игра) → плашка с авто-скрытием; reload при выходе в лобби
        this.updateToast = true;
        this.updateToastTimer = setTimeout(() => { this.updateToast = false; }, 12000);
      } else {
        this.reloadForUpdate(); // в лобби — молча
      }
    },
    reloadForUpdate() {
      if (this.updateToastTimer) clearTimeout(this.updateToastTimer);
      window.location.reload();
    },
    dismissUpdateToast() {
      this.updateToast = false;
      if (this.updateToastTimer) clearTimeout(this.updateToastTimer);
    },
    // закрыть плашку анти-фрода: запоминаем НОМЕР текущего попадания в списки (переживает reload).
    // Повторный вход в серый/чёрный → сервер шлёт больший seq → плашка снова покажется (баг оунера).
    dismissFraud() {
      if (!this.fraudNotice || this.fraudNotice.level === 'black') return;  // чёрную плашку не закрываем
      this.fraudDismissedSeq = this.$store.state.auth.fraudNoticeSeq || 0;
      localStorage.setItem('cz_fraud_dismissed_seq', String(this.fraudDismissedSeq));
    },
    onFsElementChange() {
      this.fsElement = document.fullscreenElement || document.webkitFullscreenElement || null;
    }
  },
  computed: {
    // Подпись сборки: «сборка 14.08.2026 15:20 · a1b2c3d». Метка — unix-время из build-static.sh,
    // поэтому печатаем ЧЕЛОВЕЧЕСКУЮ дату (голое «1755172800» игроку ничего не говорит); нечисловая
    // метка (ручная сборка) показывается как есть. В dev-сборке метки нет — подписи тоже.
    buildLabel() {
      const v = process.env.VUE_APP_BUILD_VERSION;
      const commit = process.env.VUE_APP_BUILD_COMMIT;
      if (!v && !commit) return '';
      let when = String(v || '');
      if (/^\d{9,}$/.test(when)) {
        const d = new Date(Number(when) * 1000);
        const p2 = (n) => String(n).padStart(2, '0');
        when = `${p2(d.getDate())}.${p2(d.getMonth() + 1)}.${d.getFullYear()} ${p2(d.getHours())}:${p2(d.getMinutes())}`;
      }
      return [t('app.build'), when, commit ? `· ${commit}` : ''].filter(Boolean).join(' ').trim();
    },
    // в партии подпись не показываем (экран занят игрой и уходит в фуллскрин)
    showBuild() {
      return this.$route.path !== '/play-web' && this.status !== 'play';
    },
    authorized() {
      return this.$store.state.auth.authorized
    },
    // Обратный отсчёт текущего этапа турнира: до старта (registration) / до конца (active) / до дедлайна
    // переноса (finished). Даты — unix-сек UTC из season.seasonInfo. null — нет активного сезона/даты этапа.
    seasonCountdown() {
      const sn = this.$store.state.season;
      if (!sn.active || !sn.seasonInfo) return null;
      const info = sn.seasonInfo;
      let label = null; let ts = null;
      if (info.state === 'registration' && info.start_at) { label = t('app.tourStartIn'); ts = info.start_at; }
      else if (info.state === 'active' && info.end_at) { label = t('app.tourEndsIn'); ts = info.end_at; }
      else if (info.state === 'finished' && info.transfer_deadline) { label = t('app.tourClaimUntil'); ts = info.transfer_deadline; }
      if (!ts) return null;
      const rem = Math.max(0, Math.floor(ts - this.seasonNow / 1000));
      return { label, text: this.fmtRemaining(rem) };
    },
    unity() {
      return Unity;
    },
    status() {
      return this.$store.state.pvp.status;
    },
    // игрок в партии (веб-клиент). Во время партии обновление НЕ перезагружаем молча — показываем плашку.
    inMatch() {
      return this.$route.path === '/play-web';
    },
    // Плашка анти-фрода в лобби (левый верхний угол): чёрный список приоритетнее серого. В партии не
    // показываем (лишний шум на игровом экране; статус игрок видит в лобби).
    fraudNotice() {
      if (!this.authorized || this.inMatch) return null;
      let n = null;
      if (this.$store.state.auth.blacklisted) {
        n = { level: 'black', cls: 'fraud-banner--black', text: t('app.blackList') };
      } else if (this.$store.state.auth.suspicious) {
        n = { level: 'grey', cls: 'fraud-banner--grey', text: t('app.greyList') };
      }
      // 🔴 ЧЁРНАЯ ПЛАШКА ПОКАЗЫВАЕТСЯ ВСЕГДА (решение оунера 2026-08-13): её нельзя закрыть, и она НЕ
      // зависит от счётчика попаданий. Без этого она могла не появиться вовсе: игрок закрыл СЕРУЮ
      // (запомнив seq), потом попал в чёрный — а бан из админки счётчик не двигает, и условие ниже
      // молча гасило единственное объяснение, почему награды перестали приходить.
      if (!n) return null;
      if (n.level === 'black') return n;
      // серая: показываем, пока номер текущего попадания БОЛЬШЕ закрытого крестиком (монотонный seq) —
      // повторный вход в серый (после снятия админом) даёт новый seq → плашка снова видна.
      if ((this.$store.state.auth.fraudNoticeSeq || 0) <= this.fraudDismissedSeq) return null;
      return n;
    },
    // куда телепортировать плашку обновления: в активный fullscreen-элемент (иначе в полноэкранной
    // партии браузер её не рендерит — видно только поддерево fullscreen-элемента), иначе в body.
    toastTarget() {
      return this.fsElement || 'body';
    },
    // Фраза обратного отсчёта до плановых работ («Через N ч M мин»); null — расписания нет/уже наступило.
    maintenanceCountdown() {
      if (this.maintenanceActive) return null;
      const r = this.maintRemain;
      if (r == null || r <= 0) return null;
      const h = Math.floor(r / 3600), m = Math.floor((r % 3600) / 60);
      return `${t('app.maintenanceIn')} ${h ? h + ' ' + t('time.h') + ' ' : ''}${m} ${t('time.min')}`;
    },
    // Веб-клиент (PixiJS) заменяет Unity: при включённом флаге НЕ монтируем <VueUnity>,
    // иначе unity-webgl грузит loaderUrl с пустым VUE_APP_UNITY_VERSION →
    // /unity_client/Build/undefined.loader.js (ошибка в консоли). Unity-режим (флаг off) не меняется.
    webClientEnabled() {
      return process.env.VUE_APP_ENABLE_WEB_CLIENT === 'true';
    }
  }
}
</script>

<style lang="scss">
@import "fonts/font.css";

#app {
  font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

html, body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  letter-spacing: 1px;
}

// Полосы прокрутки скрыты во ВСЁМ приложении (ПК и мобилка) — прокрутка остаётся, полоса не появляется.
* {
  scrollbar-width: none;          // Firefox
  -ms-overflow-style: none;       // IE/старый Edge
}
*::-webkit-scrollbar { display: none; } // Chrome/Safari/новый Edge

// 🔴 БЕЗОПАСНЫЕ ЗОНЫ TELEGRAM (волна 2, 2026-08-14). В полноэкранном мини-аппе контент уходит ПОД
// системную панель и под шапку Telegram с кнопками «свернуть/закрыть» — без этих отступов верх лобби
// и кнопки партии оказывались недоступны. Переменные ставит `watchSafeArea()` (вне Telegram — нули,
// то есть на сайте ничего не меняется). Фон (`.wrapper::before`) НЕ сдвигаем: он обязан покрывать
// экран целиком, включая зону под шапкой.
:root {
  --tg-safe-top: 0px;
  --tg-safe-right: 0px;
  --tg-safe-bottom: 0px;
  --tg-safe-left: 0px;
}

// подпись сборки — мелко, в углу, поверх фона, но НИЖЕ модалок; клики сквозь неё проходят
.build-label {
  position: fixed;
  right: calc(6px + var(--tg-safe-right));
  bottom: calc(4px + var(--tg-safe-bottom));
  z-index: 5;
  font-size: 11px;
  line-height: 1.2;
  color: rgba(243, 233, 210, .45);
  pointer-events: none;
  user-select: text;
}

.wrapper {
  width: 100%;
  min-height: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: var(--tg-safe-top);
  padding-bottom: var(--tg-safe-bottom);
  padding-left: var(--tg-safe-left);
  padding-right: var(--tg-safe-right);
  box-sizing: border-box;
}
// Фон — ОТДЕЛЬНЫЙ фикс. слой (не на .wrapper): при прокрутке контента фон всегда покрывает экран целиком.
// Высота — 100lvh (large viewport height): берётся МАКСИМАЛЬНАЯ высота вьюпорта (адресная строка скрыта) и
// НЕ меняется при её появлении/скрытии в процессе прокрутки → фон не «дышит»/не перемасштабируется (было
// inset:0 = динамический вьюпорт → cover пересчитывался на каждый показ/скрытие URL-бара, фон прыгал).
// 100vh — фолбэк для браузеров без lvh. z-index:-1 — под контентом.
.wrapper::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100lvh;
  background: url('./assets/bg.webp') no-repeat 50% / cover;
  z-index: -1;
}

.card {
  background: url('assets/menu_wrapper.webp');
  background-size: 100% 100%;
  padding: 50px;
  color: yellow;

  &-landscape {
    background: url('assets/card-landscape.webp');
    background-size: 100% 100%;
    padding: 50px;
  }
}

.back {
  position: absolute;
  right: 1em;
  top: 1em;
  padding: 0.5em 2em;
  background: url('./assets/category.webp') no-repeat;
  background-size: 100% 100%;
  border: none;
  font: inherit;
  cursor: pointer;
  text-transform: uppercase;
  color: yellow;
  font-weight: 600;
  transition: ease filter 0.3s;
  text-decoration: none;

  &:hover {
    filter: saturate(0.5);
  }
}

.chess {
  height: 100%;
  width: 100%;
  max-height: 620px;
  max-width: 1100px;
  display: flex;
  align-items: center;
  justify-content: center;

  &__blocker {
    display: none;
  }
}

@media (max-width: 720px) {
  .wrapper {
    min-height: 100%;
    height: auto;
    align-items: flex-start;       // высокий контент скроллится сверху, а не обрезается по центру
    overflow-y: auto;
    overflow-x: hidden;            // без горизонтального скролла
    padding: 12px;
    box-sizing: border-box;
  }
  // карточки лобби (вход/меню/pvp/профиль) — компактные отступы и вписаны по ширине экрана
  .card, .card-landscape {
    padding: 16px 14px;
    width: 100%;
    max-width: 480px;
    box-sizing: border-box;
    margin: 0 auto;
  }
  // окно логина (menu_wrapper) — свой паддинг/отступ на мобилке (значения из тюнера)
  .card {
    padding: 50px;
    margin: 50px auto;
  }
  .back {
    right: 8px;
    top: 8px;
    padding: 0.4em 1.1em;
    font-size: 0.85em;
    z-index: 20;
  }
  .chess {
    display: none;

    &__blocker {
      font-size: 2em;
      font-weight: 600;
      display: block;
      width: 100%;
      padding: 2em;
      margin: 1em;
      background: green;
    }
  }
}

// Плашка анти-фрода (серый/чёрный список) — левый верхний угол лобби
.tg-link-notice {
  position: fixed;
  left: 50%;
  top: calc(10px + var(--tg-safe-top, 0px));
  transform: translateX(-50%);
  z-index: 40;
  max-width: 92vw;
  box-sizing: border-box;
  padding: 8px 14px;
  border-radius: 8px;
  background: rgba(20, 16, 25, 0.92);
  border: 1px solid #c9a227;
  color: #f3e6c0;
  font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
  font-size: 15px;
  line-height: 1.25;
  text-align: center;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.tg-link-notice__close {
  flex: none;
  background: none;
  border: none;
  color: #f3e6c0;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.fraud-banner {
  position: fixed;
  left: 12px;
  top: 12px;
  z-index: 30;
  max-width: 60vw;
  padding: 8px 12px;
  border-radius: 8px;
  white-space: pre-line;
  font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.25;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.45);
  pointer-events: none;
  padding-right: 26px; /* место под крестик */
}
.fraud-banner__close {
  position: absolute;
  top: 2px;
  right: 4px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font-family: Arial, sans-serif;
  font-size: 18px;
  line-height: 18px;
  cursor: pointer;
  opacity: 0.7;
  pointer-events: auto; /* сама плашка pointer-events:none, крестик — кликабельный */
}
.fraud-banner__close:hover {
  opacity: 1;
}
.fraud-banner--grey {
  background: rgba(70, 70, 78, 0.92);
  border: 1px solid rgba(180, 180, 190, 0.6);
  color: #e9e9ef;
}
.fraud-banner--black {
  background: rgba(60, 12, 12, 0.94);
  border: 1px solid rgba(220, 90, 90, 0.7);
  color: #ffdede;
}

// Баннер активного сезона (Турнира) — виден на всех переиспользуемых экранах (Pack/PVP/Колесо/Рынок).
.season-banner {
  position: fixed;
  left: 50%;
  top: 8px;
  transform: translateX(-50%);
  z-index: 31;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: min(560px, 92vw);
  padding: 6px 14px;
  border-radius: 8px;
  background: rgba(30, 18, 46, 0.94);
  border: 1px solid rgba(224, 128, 58, 0.7);
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.45);
  font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
  font-size: 13px;
  color: #ffe27a;
}
.season-banner__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.season-banner__count {
  flex: 0 0 auto;
  white-space: nowrap;
  color: #ffcf94;
  font-variant-numeric: tabular-nums;
}
.season-banner__exit {
  flex: 0 0 auto;
  padding: 3px 10px;
  border-radius: 6px;
  border: 1px solid rgba(224, 128, 58, 0.8);
  background: rgba(224, 128, 58, 0.18);
  color: #ffe27a;
  font: inherit;
  cursor: pointer;
  white-space: nowrap;
}
.season-banner__exit:hover {
  background: rgba(224, 128, 58, 0.32);
}
@media (max-width: 720px) {
  .season-banner {
    top: 4px;
    font-size: 11px;
    padding: 5px 10px;
    gap: 8px;
  }
}

// Плашка «доступно обновление» (показывается во время партии; в лобби обновление молча)
.update-toast {
  position: fixed;
  left: 50%;
  bottom: 18px;
  transform: translateX(-50%);
  z-index: 10000;
  max-width: 92vw;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(20, 16, 26, 0.94);
  border: 1px solid rgba(210, 180, 120, 0.55);
  border-radius: 10px;
  color: #ece0c8;
  font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
  font-size: 15px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.45);

  &__text { line-height: 1.25; }
  &__close {
    flex: none;
    background: transparent;
    border: none;
    color: #d8c9a8;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    padding: 0 2px;
  }
  &__close:hover { color: #fff; }
}

// Баннер обратного отсчёта до плановых работ (не блокирует — просит завершить партии)
.maint-banner {
  position: fixed;
  left: 50%;
  top: 12px;
  transform: translateX(-50%);
  z-index: 99999;
  max-width: 94vw;
  padding: 9px 16px;
  text-align: center;
  background: rgba(60, 40, 12, 0.95);
  border: 1px solid rgba(230, 190, 110, 0.6);
  border-radius: 10px;
  color: #ffe9bf;
  font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
  font-size: 15px;
  line-height: 1.3;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.5);
}

// Блокирующий экран во время технических работ (поверх всего, гасит любые окна)
.maint-overlay {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(6, 5, 10, 0.92);
  backdrop-filter: blur(2px);

  &__box {
    max-width: 90vw;
    text-align: center;
    color: #ece0c8;
    font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
    font-size: clamp(20px, 5vw, 34px);
    line-height: 1.4;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.7);
  }
}

// Полоса загрузки игрового контента (после свежего логина).
// 🔴 ОНА НЕ ПЕРЕКРЫВАЕТ ЭКРАН (правка 2026-08-25). Раньше это был полноэкранный оверлей, и первым,
// что видел игрок ПОСЛЕ РЕГИСТРАЦИИ, была чёрная заглушка с процентами: атлас весит ~4.5 МБ, и на
// мобильном канале она висела заметно. Ожидание без возможности играть — прямая причина ухода из
// первой сессии, поэтому теперь это узкая полоска внизу: контент греется фоном, а игрок в это время
// выбирает сторону и получает дар.
.preloader {
  position: fixed;
  left: 50%;
  bottom: 14px;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: none; // ничего не перехватываем: клики уходят экрану под полоской

  &__box {
    width: 320px;
    max-width: 86vw;
    text-align: center;
    color: #ece0c8;
    font-family: agencyfb_reg, Helvetica, Arial, sans-serif;
    background: rgba(8, 6, 12, 0.82);
    border: 1px solid rgba(210, 180, 120, 0.35);
    border-radius: 10px;
    padding: 8px 14px 10px;
  }
  &__title { font-size: 14px; margin-bottom: 6px; letter-spacing: 0.04em; opacity: 0.9; }
  &__bar {
    height: 8px;
    border: 1px solid rgba(210, 180, 120, 0.55);
    border-radius: 9px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.06);
  }
  &__fill {
    height: 100%;
    background: linear-gradient(90deg, #c79a4e, #f0c25a);
    transition: width 0.2s ease;
  }
  &__pct { margin-top: 4px; font-size: 12px; opacity: 0.75; }
  &__skip {
    margin-top: 6px;
    pointer-events: auto; // единственный кликабельный элемент полоски — «скрыть»
    background: transparent;
    border: 1px solid rgba(210, 180, 120, 0.5);
    color: #d8c9a8;
    padding: 3px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-family: inherit;
    font-size: 14px;
  }
  &__skip:hover { background: rgba(210, 180, 120, 0.12); }
}
</style>
